import React, { forwardRef } from 'react';
import Icon from '../AppIcon';

const Checkbox = forwardRef(({ 
  checked = false,
  onChange,
  disabled = false,
  label,
  description,
  className = '',
  error = false,
  ...props 
}, ref) => {
  const baseClasses = 'peer h-4 w-4 shrink-0 rounded-sm border border-primary ring-offset-background focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 data-[state=checked]:bg-primary data-[state=checked]:text-primary-foreground';
  
  const errorClasses = error ? 'border-destructive' : '';
  
  const checkboxClasses = `${baseClasses} ${errorClasses} ${className}`?.trim()?.replace(/\s+/g, ' ');

  const handleChange = (event) => {
    if (onChange) {
      onChange(event?.target?.checked, event);
    }
  };

  const checkboxElement = (
    <div className="relative">
      <input
        ref={ref}
        type="checkbox"
        checked={checked}
        onChange={handleChange}
        disabled={disabled}
        className="sr-only"
        {...props}
      />
      <div className={checkboxClasses} data-state={checked ? 'checked' : 'unchecked'}>
        {checked && (
          <Icon 
            name="Check" 
            className="w-3 h-3 text-current absolute top-0.5 left-0.5" 
          />
        )}
      </div>
    </div>
  );

  if (label || description) {
    return (
      <div className="flex items-start space-x-3">
        {checkboxElement}
        <div className="grid gap-1.5 leading-none">
          {label && (
            <label 
              className="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70 cursor-pointer"
              onClick={() => !disabled && onChange && onChange(!checked)}
            >
              {label}
            </label>
          )}
          {description && (
            <p className="text-sm text-muted-foreground">
              {description}
            </p>
          )}
        </div>
      </div>
    );
  }

  return checkboxElement;
});

Checkbox.displayName = 'Checkbox';

export default Checkbox;